"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const entity_1 = require("../../type/entity");
function getCompletionStatusForILT(state, states) {
    const sessionStates = states.filter((currentState) => currentState.registerType === entity_1.ILTRegisterType.ASSIGNED || currentState.registerType === entity_1.ILTRegisterType.ENROLLED);
    if (state.progressMeasure === 1) {
        return entity_1.CompletionStatus.COMPLETE;
    }
    else if (sessionStates.length > 0) {
        return entity_1.CompletionStatus.INCOMPLETE;
    }
    return entity_1.CompletionStatus.NOT_ATTEMPTED;
}
exports.getCompletionStatusForILT = getCompletionStatusForILT;
//# sourceMappingURL=getCompletionStatusForILT.js.map